import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ObjectNameTranslatePipe } from './object-name-translate.pipe';

@Pipe({
  name: 'objectName',
})
export class ObjectNamePipe implements PipeTransform {
  objectNameTranslatePipe = new ObjectNameTranslatePipe(this.translateService);

  constructor(private translateService: TranslateService) {
  }

  transform(value: { name?: string; title?: string }): string {
    if (value) {
      if (value.title) {
        return value.title;
      } else {
        return this.objectNameTranslatePipe.transform(value.name);
      }
    }
    return '';
  }
}

@NgModule({
  exports: [
    ObjectNamePipe,
  ],
  declarations: [
    ObjectNamePipe,
  ],
})
export class ObjectNamePipeModule {
}
